import { mapGetters } from "vuex"

import string_utilities from "./StringUtilities"

const phase_utilities = {
    mixins: [string_utilities],
    methods: {
        phase_by_id (phase_id) {
            return this.project_phases.find(phase => phase.id === phase_id) || { name: phase_id, code_constant: phase_id }
        },
        phase_standardized_title (phase, raw = false) {
            if(!phase) return ""
            if(!raw && (phase.title !== null)) return phase.title
            const title = this.phase_by_id(phase.phase).code_constant
            if(title === "other") return "Other"
            return title
        },
        phase_fee_remaining (phase) {
            if(phase) return phase.fee - phase.computed_spent
            return 0
        },
        phase_fee_projected (phase) {
            let total = 0
            if(phase) {
                const tasks = this.tasks_by_phase_id(phase.id).filter(task => !task.completed_at)
                total = tasks.reduce((total, task) => {
                    return total + task.computed_projected_fee
                }, 0)
            }
            return Math.round(total)
        },
        phase_milestones (phase) {
            return this.raw_task_records.filter(task => !task.milestone_id && (task.phase_id === phase.id))
        },
        phase_starts_at (phase) {
            let min = null
            this.phase_milestones(phase).forEach(task => {
                const task_starts_at = this.task_starts_at(task)
                if(task_starts_at) {
                    const starts_at = this.$moment(task_starts_at)
                    if(!min) min = starts_at
                    else if(starts_at.isBefore(min)) min = starts_at
                }
            })
            if(!min) min = this.phase_ends_at(phase)
            return min
        },
        phase_ends_at (phase) {
            let max = null
            this.phase_milestones(phase).forEach((task) => {
                const task_ends_at = this.task_ends_at(task)
                if(task_ends_at) {
                    const ends_at = this.$moment(task_ends_at)
                    if(!max) max = ends_at
                    else if(ends_at.isAfter(max)) max = ends_at
                }
            })
            return max
        },
        tasks_by_phase_id (phase_id) {
            return this.raw_task_records.filter(task => task.phase_id === phase_id)
        },
        milestone_for_task (task) {
            if(!task || !task.milestone_id) return task
            return this.entity_record("task", task.milestone_id) || task
        },
        task_starts_at (task) {
            if(!task) return null
            if(!task.milestone_id || task.starts_at) return task.starts_at
            return this.milestone_for_task(task).starts_at
        },
        task_ends_at (task) {
            if(!task) return null
            if(!task.milestone_id || task.ends_at) return task.ends_at // task.proxied_ends_at || task.ends_at
            return this.milestone_for_task(task).ends_at
        }
    },
    computed: {
        ...mapGetters(["entity_records", "entity_record"]),
        ...mapGetters(["entity_records"]),
        raw_phase_records () {
            return this.entity_records("phase")
        },
        raw_task_records () {
            return this.entity_records("task")
        },
        project_phases () {
            return this.dictionary("project_phase")
        }
    }
}

export default phase_utilities
